import { useTranslation } from 'react-i18next';
import { IStandardEnum } from 'types/global/enum.interface';
import { enumToObject } from 'utils/global/object.utils';

export const useEnumToSelectOptions = () => {
  const { t } = useTranslation();

  const getSelectOptions = <T>(
    ENUM: IStandardEnum<T>,
    i18nextPrefix?: string
  ) =>
    enumToObject<T>(ENUM)
      .filter(object => object.value != -1)
      .map(object => ({
        label: i18nextPrefix ? t(`${i18nextPrefix}.${object.key}`) : object.key,
        value: object.value,
      }));

  const getStatusOptions = (
    ENUM: IStandardEnum<number>,
    initialStatus: number,
    i18nextPrefix: string
  ) => {
    const selectOptions = getSelectOptions(ENUM, i18nextPrefix);

    return initialStatus !== 1
      ? selectOptions.filter(option => option.value !== 1)
      : selectOptions;

    // return initialStatus !== 1
    // ? selectOptions.map(option =>
    //     option.value === 1 ? { ...option, isDisabled: true } : option
    //   )
    // : selectOptions;
  };


  return { getSelectOptions, getStatusOptions };
};

export const getYearsSelectOptions = (yearsBack?: number) => {
  const array = new Array(yearsBack ?? 100).fill({});
  return array.map((value, index) => ({
    value: new Date().getFullYear() - index,
    label: new Date().getFullYear() - index,
  }));
};
